type Props = (shortID: string) => string;

const getShortUrl: Props = (shortID) => {
  return `${process.env.REACT_APP_SHORT_URL}${shortID}`;
};

export default getShortUrl;
